module.exports = __webpack_public_path__ + "static/img/cooperations.6a1fae9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperations.png
// module id = zXXI
// module chunks = 1